const MONTH_CODES = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]

// Formats a transfer into the #MUT-YYYY-MMM-DD-NN invoice code,
// e.g. id 4 created 15-11-2025 → "#MUT-2025-NOV-15-04".
const formatTransferCode = (transferData) => {
  const dateCreated = new Date(transferData.created_at)
  const year = dateCreated.getFullYear()
  const month = MONTH_CODES[dateCreated.getMonth()]
  const day = `${dateCreated.getDate()}`.padStart(2, "0")
  const sequence = `${transferData.id}`.padStart(2, "0")
  return `#MUT-${year}-${month}-${day}-${sequence}`
}

const TransferInvoiceHeader = ({ transferData }) => {
  const dateCreated = new Date(transferData.created_at)
  const formattedDate = `${dateCreated.getDate()}-${dateCreated.getMonth() + 1}-${dateCreated.getFullYear()}`
  return <>
    <div className="row invoice-header">
      <div className="col-6">
        <div className="mainbrand navbar-brand fontBold">
          <h1 className="ms-0">SJ SAMARINDA</h1>
        </div>
        <p className="small-text">Surat Jalan Mutasi Barang</p>
      </div>

      <div className="col-6 mt-4" style={{ paddingLeft: "100px" }}>
        <address className="small-text">
          <span className="label text-start">Tanggal</span> :{" "}
          {formattedDate} <br />
          <span className="label text-start">Nomor nota</span> :{" "}
          {formatTransferCode(transferData)} <br />
          <span className="label text-start">Dari</span> :{" "}
          {transferData.from_location} <br />
          <span className="label text-start">Ke</span> :{" "}
          {transferData.to_location} <br />
        </address>
      </div>
    </div>
    <hr style={{ margin: "8px 0px 8px 0px", height: "3px" }} />
  </>
}

export default TransferInvoiceHeader
